// extracted by mini-css-extract-plugin
module.exports = {"default":"BorderlessButton--default--23ASz","danger":"BorderlessButton--danger--23U3x","disabled":"BorderlessButton--disabled--LcJEk"};